import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * French INSEE generator following Single Responsibility Principle
 */
export class FrGenerator extends BaseGenerator {
  generate(options = {}) {
    const { gender = null, birthYear = null } = options;

    // Gender (1 digit: 1=male, 2=female)
    let genderDigit;
    if (gender === 'male') {
      genderDigit = '1';
    } else if (gender === 'female') {
      genderDigit = '2';
    } else {
      genderDigit = this.randomInt(1, 2).toString();
    }

    // Birth year (2 digits)
    const year = birthYear ? birthYear.toString().slice(-2) : this.padZero(this.randomInt(0, 99), 2);

    // Birth month (2 digits)
    const month = this.padZero(this.randomInt(1, 12), 2);

    // Department (2 digits) - common French departments
    const departments = ['01', '02', '06', '13', '33', '59', '69', '75', '92', '93'];
    const department = departments[this.randomInt(0, departments.length - 1)];

    // Municipality (3 digits)
    const municipality = this.padZero(this.randomInt(1, 999), 3);

    // Birth order (3 digits)
    const birthOrder = this.padZero(this.randomInt(1, 999), 3);

    // Calculate check digits
    const first12 = genderDigit + year + month + department + municipality + birthOrder;
    const remainder = parseInt(first12) % 97;
    const checkDigits = this.padZero(97 - remainder, 2);

    return first12 + checkDigits;
  }
}